import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {bindActionCreators} from 'redux';
import {Button, Icon} from 'semantic-ui-react';
import setDisplayName from 'recompose/setDisplayName';
import {startCreatePrizeAction} from './actions';

const mapStateToProps = state => ({
  className: 'create-prize-button',
  primary: true,
  children: (
    <React.Fragment>
      <Icon name='add' />
      <span>Create New {state.listPrizes.filterByType === 'RAFFLE' ? 'Sweeps' : 'Prize'}</span>
    </React.Fragment>
  )
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onClick: startCreatePrizeAction
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  setDisplayName('CreatePrizeButton')
)(Button);



// WEBPACK FOOTER //
// ./public/pages/PrizeCreator/CreatePrizeButton.jsx